module.exports = __webpack_public_path__ + "img/startbild_default_header-video_2.c5334eca.jpg";